// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"vq-z","breadcrumbForward":"wq-z","breadcrumbBack":"xq-z","selected":"yq-z"};